let constants = {
    ACTIONS: {
      GET_APPOINTMENT_SLOT: 'GET_APPOINTMENT_SLOT',
      SET_TIME_SLOT_GLOBAL:'SET_TIME_SLOT_GLOBAL'
    },
    TEXTS: {},
  };
  export default constants;